// extracted by mini-css-extract-plugin
export default {"wrapper":"FormNavigation_wrapper__xrOBz","buttonWrapper":"FormNavigation_buttonWrapper__YbcD-","flipButtons":"FormNavigation_flipButtons__6KLbD"};